export var cleanupData = function cleanupData(productSets, displaySwatches, displayEditorial) {
  // Take an array of collection product sets and manipulate the data based on collection settings
  // If we are not requesting the colorways, set the faceout color
  if (!displaySwatches) {
    productSets.forEach(function (productSet) {
      productSet.products.edges.forEach(function (_ref) {
        var _ref$node = _ref.node,
            component = _ref$node.component,
            product = _ref$node.product,
            faceout = _ref$node.faceout;

        if (component) {
          return;
        }
        /* eslint-disable no-param-reassign */


        product.colorways = {
          edges: [{
            node: faceout
          }]
        };
      });
    });
  } // Split the sizes on the products


  productSets.forEach(function (productSet) {
    productSet.products.edges.forEach(function (_ref2) {
      var product = _ref2.node.product;
      if (product === null) return;
      product === null || product === void 0 ? void 0 : product.colorways.edges.forEach(function (_ref3) {
        var _node$sizesAvailable;

        var node = _ref3.node;
        (_node$sizesAvailable = node.sizesAvailable) === null || _node$sizesAvailable === void 0 ? void 0 : _node$sizesAvailable.forEach(function (size) {
          size.sizesSplit = size.size.replace(/\s/g, '').split(/[/-]/).reduce(function (acc, curr) {
            return acc[curr] = true, acc;
          }, {});
        });
      });
    });
  }); // Loop through all of the images and see if there is an editorial match. If there is, swap the images

  if (displayEditorial) {
    productSets.forEach(function (_ref4) {
      var edges = _ref4.products.edges;
      return edges.forEach(function (_ref5) {
        var product = _ref5.node.product;
        product === null || product === void 0 ? void 0 : product.colorways.edges.forEach(function (_ref6) {
          var node = _ref6.node;
          var assets = {
            node: node
          };

          if (!assets) {
            return;
          }

          if (edges.length > 1 && edges[1].node.isEditorial) {
            node.image = edges[1].node.image;
          }
        });
      });
    });
  }

  return productSets;
};